import { render, staticRenderFns } from "./ExchangeRecordPage.vue?vue&type=template&id=a81d8358&scoped=true"
import script from "./ExchangeRecordPage.vue?vue&type=script&lang=js"
export * from "./ExchangeRecordPage.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRecordPage.vue?vue&type=style&index=0&id=a81d8358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81d8358",
  null
  
)

export default component.exports